import { Component } from '@angular/core';

@Component({
  selector: 'order-card-dialog',
  templateUrl: './order-card-dialog.component.html',
  styleUrls: ['./order-card-dialog.component.scss']
})
export class OrderCardDialogComponent {

}
